var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloodSugar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e7ebec;\n      }\n\n      .cls-2 {\n        fill: #a8bcca;\n      }\n\n      .cls-3 {\n        fill: #bbb9ba;\n      }\n\n      .cls-4 {\n        fill: #d15415;\n      }\n\n      .cls-5 {\n        fill: #345065;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128,185.27h0c31.63,0,57.27-25.64,57.27-57.27v-63.43c0-14.67-11.9-26.57-26.57-26.57h-61.4c-14.67,0-26.57,11.9-26.57,26.57v63.43c0,31.63,25.64,57.27,57.27,57.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.82,
    y: 168.91,
    width: 16.36,
    height: 49.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.18,119.82h53.64c3.26,0,5.91-2.65,5.91-5.91V60.27c0-3.26-2.65-5.91-5.91-5.91h-53.64c-3.26,0-5.91,2.65-5.91,5.91v53.64c0,3.26,2.65,5.91,5.91,5.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.51,128.74h-23.72c-4.15,0-7.52,3.37-7.52,7.52,0,10.09,8.18,18.26,18.26,18.26h12.98v-25.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.21,128.74h-23.72v25.79h12.98c10.09,0,18.26-8.18,18.26-18.26,0-4.15-3.37-7.52-7.52-7.52Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.9,92.74c0-7.79,14.1-28.21,14.1-28.21,0,0,14.1,20.42,14.1,28.21s-6.31,14.1-14.1,14.1-14.1-6.31-14.1-14.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodSugar);
export default __webpack_public_path__ + "static/media/blood-sugar.18a187d0ad24496f6dcb7ebef7c9cec0.svg";
export { ForwardRef as ReactComponent };